import { authHeaders } from "../api/api";
import { useAuth } from "../contexts/AuthContext";

/**
 * Who a product-detail request is made as — pass the result to
 * productQueryOptions() (src/api/products.js).
 *
 * Only a fully resolved account counts as signed in: while a stored token is
 * still being checked (or if that check failed) the request goes out
 * anonymously and is cached under the anonymous key, so an authenticated
 * response can never land in a cache entry another visitor could read.
 * `ready` is false until auth has resolved — wait for it before fetching, or
 * a verified adult's first load of an age-restricted product would 403.
 * Safe outside an AuthProvider (treated as anonymous and ready).
 */
export function useProductViewer() {
  const auth = useAuth();
  const userId = auth?.token && auth?.user?.id != null ? auth.user.id : null;
  return {
    userId,
    headers: userId != null ? authHeaders(auth.token) : undefined,
    ready: !auth?.loading,
  };
}
